/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next';
import SecondaryBtnLight from '../../../components/common/form/SecondaryBtnLight';
import { useNavigate, useParams } from 'react-router-dom';
import { LogoIcon } from '../../../components/common/svg/AllSvg';
import Canonical from '../../../components/common/layout/Canonical';
import { useDispatch } from 'react-redux';
import { languages } from '../../../shared/utils/languages';
import { uiActions } from '../../../shared/store/ui-Slice';
import { useEffect } from 'react';

const NotFound = () => {
    const { i18n, t } = useTranslation('common');
    const navigate = useNavigate();
    const params = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!!params?.lang) {
            if (params?.lang === "hi" || params?.lang === "en" || params?.lang === "mr") {
                let obj: any = languages?.find((item: any) => item?.value === params?.lang);

                if (!!obj && Object?.keys(obj)?.length > 0) {
                    i18n.changeLanguage(obj?.value);
                    dispatch(uiActions.changeLang(obj?.value));
                } else {
                    i18n.changeLanguage("en");
                    dispatch(uiActions.changeLang("en"));
                }
            } else {
                navigate("/404")
            }
        } else {
            i18n.changeLanguage("en");
            dispatch(uiActions.changeLang("en"));
        }
    }, [params?.lang])

    return (
        <div className="w-full h-full dark:bg-bgDarkDull bg-white min-h-screen pt-[80px] xlx:pt-[95px] pb-[40px] flex items-center justify-center">
            <Canonical />
            <div className="w-full h-full container flex flex-col items-center justify-center" id="home">
                <LogoIcon />
                <h1 className='text-primaryText dark:text-white uppercase font-bold mt-[15px] text-center'>{t("not_found.title")}</h1>
                <h4 className='text-primary font-semibold text-center'>{t("not_found.subtitle")}</h4>
                <h5 className='text-center text-blackDull dark:text-textBlackDull font-medium mt-[20px] max-w-[600px]'>{t("not_found.desc")}</h5>
                <div className='flex items-center justify-center w-full mt-[35px] mb-[70px]'>
                    <SecondaryBtnLight title={t("not_found.go_back")} css="px-[40px] xlx:px-[64px] uppercase font-bold rounded-[6px] text-base leading-snug w-fit text-primary border border-primary focus:!shadow-[0_0_0_3px_#059db25e] hover:!shadow-[0_0_0_3px_#059db25e]" onClick={() => !!params?.lang ? navigate(`/${params?.lang}`) : navigate(`/`)} />
                </div>

                <img src={require("../../../assets/images/coming-soon.png")} alt="not-found" />
            </div>
        </div>
    );
};

export default NotFound;